import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function PrekrsajnoPravo() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Prekršajno pravo" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Prekršajno pravo</h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Prekršajno pravo
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Izborni
              </p>
              <p>
                <strong>Broj ECTS:</strong> 4
              </p>
              <p>
                <strong>Uslov:</strong> nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Osnovni cilj predmeta Prekršajno pravo je upoznavanje studenata
                sa sistemom kaznenih delikata u našem pravu a posebno sa
                prekršajima kao vrstom delikata prekršajnom odgovornošću
                prekršajnim sankcijama i postupkom u kome se učiniocima
                prekršaja izriču prekršajne sankcije kao i postupkom njihovog
                izvršenja. Takođe cilj ovog predmeta je upoznati studente kako
                sa materijalnim dijelom tako i sa procesnim dijelom kao i sa
                bogatom sudskom praksom naših sudova.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Savladavanjem studijskog sadržaja ovog predmeta studenti će
                steći znanja o prekršajima kao posebnoj vrsti delikata osnovnim
                institutima prekršajnog prava kao i praktična znanja o pojedinim
                grupama prekršaja postupku koji se vodi prema učiniocima tih
                delikata kao i ulozi policije u tim postupcima. Razvijanje
                vještina i praktična primena stečenih znanja rešavanje
                konkretnih prekršajnopravnih situacija sastavljanje
                dokumentacije u skladu sa odredbama prekršajnog prava.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                Materijalno prekršajno pravo Pojam prekršajnog prava Istorijski
                razvoj prekršajnog prava Izvori prekršajnog prava Pojam
                prekršaja Osnovi isključenja prekršaja Prekršajna odgovornost
                Subjekti prekršajne odgovornosti Osnovi isključenja prekršajne
                odgovornosti Sticaj prekršaja Saučesništvo u prekršaju Pokušaj
                prekršaja Prekršajne sankcije: Kazne Opomena Zaštitne mjere
                Prekršajna odgovornost maloljetnika Prekršaji protiv javnog reda
                i mira Saobraćajni prekršaji Prekršajni postupak Vrste i
                stadijumi prekršajnog postupka Izvršno prekršajno pravo Mjere za
                obezbjeđenje prisustva okrivljenog Saslušanje okrivljenog
                Saslušanje svjedoka Sporazum o priznanju krivice Pretres Presuda
                Redovni pravni ljekovi Vanredni pravni ljekovi Prekršajni
                postupak prema maloljetnicima Prekršajni postupak koji vode
                organi uprave Nadležnost i sastav prekršajnih sudova Okrivljeni
                Oštećeni Javni tužilac i drugi organi ovlašćeni na pokretanje
                postupka.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>2P + 2V</td>
                    <td>
                      Materijalno prekršajno pravo Pojam prekršajnog prava
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>2P + 2V</td>
                    <td>
                      Istorijski razvoj prekršajnog prava Izvori prekršajnog
                      prava
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>2P + 2V</td>
                    <td>
                      Pojam prekršaja Osnovi isključenja prekršaja Prekršajna
                      odgovornost Subjekti prekršajne odgovornosti Osnovi
                      isključenja prekršajne odgovornosti
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>2P + 2V</td>
                    <td>
                      Sticaj prekršaja Saučesništvo u prekršaju Pokušaj
                      prekršaja
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>2P + 2V</td>
                    <td>
                      Prekršajne sankcije: Kazne Opomena Zaštitne mjere
                      <br />
                      Praktična nastava. Posjeta Sudu za prekršaje.
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td></td>
                    <td>Kolokvijum I</td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>2P + 2V</td>
                    <td>
                      Prekršajna odgovornost maloljetnika Prekršaji protiv
                      javnog reda i mira Saobraćajni prekršaji
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>2P + 2V</td>
                    <td>
                      Prekršajni postupak Vrste i stadijumi prekršajnog postupka
                    </td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>2P + 2V</td>
                    <td>
                      Nadležnost i sastav prekršajnih sudova Okrivljeni Oštećeni
                      Javni tužilac i drugi organi ovlašćeni na pokretanje
                      postupka
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>2P + 2V</td>
                    <td>
                      Mjere za obezbjeđenje prisustva okrivljenog Saslušanje
                      okrivljenog Saslušanje svjedoka Sporazum o priznanju
                      krivice Pretres
                    </td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>2P + 2V</td>
                    <td>
                      Presuda Redovni pravni ljekovi Vanredni pravni ljekovi
                      <br />
                      Praktična nastava. Presuda Višem sudu za prekršaje.
                      Analiza sudske prakse.
                    </td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td></td>
                    <td>Kolokvijum II</td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>2P + 2V</td>
                    <td>Prekršajni postupak prema maloljetnicima</td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>2P + 2V</td>
                    <td>Prekršajni postupak koji vode organi uprave</td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>2P + 2V</td>
                    <td>
                      Izvršno prekršajno pravo
                      <br />
                      Praktična nastava. Analiza sudske prakse. Simulacija
                      suđenja.
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td></td>
                    <td>Sveobuhvatni ispit</td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td></td>
                    <td>Ovjera semestra i upis ocjena</td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td></td>
                    <td>Popravni ispitni rok</td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 4č / 3.00h</td>
                            <td>Ukupno: 80h</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 2č / 1.3h</td>
                            <td>Nastava + završni ispit: 60h</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 2č / 1.3h</td>
                            <td>Priprema i ovjera semestra: 6h</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 14h</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default PrekrsajnoPravo;
